import * as types from "../actions/actionTypes"
import initialState from "./initialState";

export default function userReducer(state = initialState.user, action) {
    switch (action.type) {
        case types.LOAD_USER_SUCCESS:
            return action.user;
        case types.UPDATE_USER_DETAILS:
            return {
                ...state,
                firstName: action.details.firstName,
                surname: action.details.surname
            };
        case types.UPDATE_USER_PREFERREDMEASUREMENTS:
            return {
                ...state,
                preferredMeasurementUnits: action.units
            };
        case types.NETWORK_FOLLOW_RIDER:
            state.riderNetwork.following.push({ userId: action.user.id, pending: false, reject: false, restricted: false, firstName: action.user.firstName, surname: action.user.surname })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_REQUEST_FOLLOW_RIDER:
            state.riderNetwork.following.push({ userId: action.user.id, pending: true, reject: false, restricted: false, firstName: action.user.firstName, surname: action.user.surname })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_UNFOLLOW_RIDER:
            state.riderNetwork.following.map((user, idx) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    state.riderNetwork.following.splice(idx, 1);
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_REMOVE_FOLLOWING_RIDER:
            state.riderNetwork.followers.map((user, idx) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    state.riderNetwork.followers.splice(idx, 1);
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_BLOCK_RIDER:
            state.riderNetwork.followers.map((user) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    user.blocked = true; 
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            }; 
        case types.NETWORK_UNBLOCK_RIDER:
            state.riderNetwork.followers.map((user) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    user.blocked = false;
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_APPROVE_FOLLOWER_RIDER:
            state.riderNetwork.followers.map((user) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    user.pending = false;
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.NETWORK_REJECT_FOLLOWER_RIDER:
            state.riderNetwork.followers.map((user, idx) => {
                if (user.userId.toLowerCase() == action.user.id.toLowerCase()) {
                    state.riderNetwork.followers.splice(idx, 1);
                }
            })
            return {
                ...state,
                riderNetwork: state.riderNetwork
            };
        case types.UPDATE_AVATAR_VERSION:
            return {
                ...state,
                avatarVersion: action.version,
                avatarAvailable: true
            };
        case types.UPDATE_BANNER_VERSION:
            return {
                ...state,
                bannerVersion: action.version,
                bannerAvailable: true
            };
        case types.LOGOUT_SUCCESS:
            return initialState.user;
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js